import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../../../shared/locales.en.json";
import ja from "../../../shared/locales.ja.json";

// i18next initialization
// - Default language: ja
// - Fallback: en
// - Namespace: use the default "translation" with the JSON shape as-is
void i18n.use(initReactI18next).init({
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  lng: "ja",
  resources: {
    en: { translation: en as unknown as Record<string, unknown> },
    ja: { translation: ja as unknown as Record<string, unknown> },
  },
  returnNull: false,
});

export { i18n };
